<template>
  <div class="product-list" id="product-list">
    <v-slide-group 
      v-model="index"
      prev-icon="" 
      next-icon=""
    >
      <v-slide-item
        v-for="item in items"
        :key="item.shoppingCartItemId"
      >
        <template v-slot:default>
          <div
            class="product-list__item"
            :class="$root.isMobile ? '' : 'item--large'"
            @click="onProductsPreview()"
          >
            <div 
              class="item__image"
              :class="$root.isMobile ? '' : 'image--large'"
              :style="{'background-image': 'url(' + getItemImage(item) + ')'}"
            >
              <div v-if="isVideo(item)" class="item__frame" :style="{ 'background-image': `url('/img/video-frame-cart.svg')` }"></div>
            </div>
            <div class="product-list__item-container">
              <div class="item__title text-wrap" :class="$root.isMobile ? '' : 'title--large'" v-html="getItemTitle(item)">
              </div>
              <div :class="'item__price ' + (isDiscountedPrice(item) ? 'price--discounted' : '')">
                <span :class="isDiscountedPrice(item) ? 'price__new' : ''">
                  {{ formatAmount(item.totalPrice, rounding.productListTotal) }}
                </span>
                <span v-show="isDiscountedPrice(item)" class="price__original" :class="lang !== 'ru' ? 'price__original--break' : ''">
                  {{ formatAmount(item.originalPrice, rounding.productListOriginal) }}
                </span>
                <span v-show="item.promocodesCount" class="price__count">{{ item.promocodesCount + '&nbsp;' + $t('saleSnackbar/qty') }}</span>
              </div>
            </div>
          </div>
        </template>
      </v-slide-item>
    </v-slide-group>  

    <div 
      v-if="$root.isMobile && items.length < 4 && items.length > 2"
      class="product-list__item-placeholder"
      :style="{ 'width': placeholderWidth.toString() + 'px' }"
    >
    </div>

    <div 
      v-if="!$root.isMobile && items.length < 4"
      class="product-list__item-placeholder product-list__item-placeholder--large"
      :style="{ 'width': 'calc(100% - ' + placeholderWidth.toString() + 'px)' }"
    >
    </div>

    <div v-if="!$root.isMobile && index != 0 && items.length > 3" class="product-list__nav-icon nav-icon--left">
      <Button 
        @click="goPrevItem"
        variant="clear"
        view="light"
        shape="circle"
        size="lg"
      >
        <slot name="before">
          <span class="rr-button__icon rr-button__icon_auto">
            <base-icon width="47" height="47" viewBox="0 0 48 48">
              <icon-arrow-left fill="black" />
            </base-icon>
          </span>
        </slot>
      </Button>
    </div>
    <div v-if="!$root.isMobile && index != items.length-1 && items.length > 3" class="product-list__nav-icon nav-icon--right">
      <Button 
        @click="goNextItem"
        variant="clear"
        view="light"
        shape="circle"
        size="lg"
      >
        <slot name="before">
          <span class="rr-button__icon rr-button__icon_auto">
            <base-icon width="47" height="47" viewBox="0 0 48 48">
              <icon-arrow-right fill="black" />
            </base-icon>
          </span>
        </slot>
      </Button>
    </div>

    <v-dialog
      v-model="productDialog"
      :fullscreen="$root.isMobile"
      persistent
    >
      <ProductPreview
        :items_="products"
        :class="$root.isMobile ? '' : 'product-dialog--large'"
        @selected="onPhotoSelected" 
        @cancelled="productDialog=false" 
      />
    </v-dialog>

    <PhotoPreview
      :isOpened="photosDialog"
      :photos="photos"
      :checked="[]"
      :noFooter="true"
      :currentIndex="photosIndex"
      @cancelled="photosDialog=false"
    />

    <VideoPreview
      v-show="videoPreviewDialog"
      :isOpened="videoPreviewDialog"
      :items="previewVideos"
      :isDemo="true"
      :noCheckbox="false"
      :noCart="true"
      :enableDownload="false"
      :currentIndex="currentVideoIndex"
      :key_="videoPreviewDialogKey"
      @closed="videoPreviewDialog=false" 
    />

  </div>
</template>


<script lang="js">
import { mapGetters } from 'vuex';
import axios from 'axios';
import PhotoPreview from '@/components/photo-preview/photo-preview.vue';
import VideoPreview from "@/components/video-preview/video-preview.vue";
import ProductPreview from '@/components/product-preview/product-preview.vue';
import BaseIcon from '@/components/base-icon/base-icon.vue';
import IconArrowLeft from '@/components/icons/icon-arrow-left.vue';
import IconArrowRight from '@/components/icons/icon-arrow-right.vue';
import { ProductTypes } from '@/product-types';
import Common from '@/plugins/common';

export default {
  name: 'ProductList',
  props: {
    items: Array,
  },
  components: {
    PhotoPreview,
    VideoPreview,
    ProductPreview,
    BaseIcon,
    IconArrowLeft,
    IconArrowRight,
  },
  data() {
    return {
      index: 0,
      productTypes: ProductTypes,
      productDialog: false,
      products: [],
      photosDialog: false,
      photos: [],
      photosIndex: 0,
      placeholderWidth: 0,
      videoPreviewDialog: false,
      videoPreviewDialogKey: '',
      previewVideos: [],
      currentVideoIndex: 0,
      event: null,
    };
  },
  computed: {
    ...mapGetters('SettingsState', ['lang', 'defaultLanguage', 'rounding']),
  },
  watch: {
    productDialog() {
      if (this.productDialog) {
        document.documentElement.style.overflowY = 'hidden';
        document.body.style.overflowY = 'hidden';
      }
      if (!this.productDialog) {
        document.documentElement.style.overflowY = '';
        document.body.style.overflowY = '';
      }
    },
  },
  methods: {
    formatAmount(amount, onlyInteger = true) {
      return Common.formatAmount(amount, onlyInteger);
    },
    getItemImage(item) {
      const type = item.product.productType;
      if (type.length === 0) return '';

      if (type == this.productTypes.photos_with_me) {
        return '/img/all-photos.svg';
      } else if (type == this.productTypes.photosWithFrame) {
        return '/img/all-photos-in-frame.svg';
      } else if (type == this.productTypes.promocode) {
        return '/img/promocode.svg';
      } else if (this.isVideo(item)) {
        return item.product.video.resources.thumbnailUrl || item.product.video.resources.gifUrl;
      } else {
        const url = item.product.photo.resources.preview;
        if (url.length == 0) return '';
        
        return url;
      }
    },
    getItemTitle(item) {
      const type = item.product.productType;
      if (type.length === 0) return '';

      if (type == this.productTypes.photos_with_me) {
        return this.$t('productPreview/productAllPhotos').toString();
      } else if (type == this.productTypes.photosWithFrame) {
        return item.product.title;
      } else if (type == this.productTypes.photo) {
        return this.$t('productPreview/productDigitalPhoto').toString();
      } else if (type == this.productTypes.promocode) {
        return item.product.title;
      } else if (type === this.productTypes.video) {
        return item.product.title;
      } else {
        return this.$t('searchResults/productPhotoFrame').toString();
      }
    },
    isDiscountedPrice(item) {
      return item.originalPrice != item.totalPrice;
    },
    isVideo(item) {
      const type = item.product.productType;
      if (type.length === 0) return false;
      return type === this.productTypes.video;
    },
    goPrevItem() {
      if (this.index - 4 >= 0) {
        this.index -= 4;
      } else {
        this.index = 0;
      }
    },
    goNextItem() {
      if (this.index + 4 < this.$props.items.length) {
        this.index += 4;
      } else {
        this.index = this.$props.items.length - 1;
      }
    },
    getItemPhotos(item, onlyPhotoWithMe = false) {
      const type = item.product.productType;
      if (type.length == 0) return [];

      if (onlyPhotoWithMe) {
        if (type != this.productTypes.photos_with_me && type != this.productTypes.photosWithFrame) {
          return [];
        }
      }

      let photos = [];
      if (type == this.productTypes.photos_with_me) {
        photos = Object.assign([], item.product.photos);
      } else if (type == this.productTypes.photosWithFrame) {
        photos = Object.assign([], item.product.photos);
      } else if (this.isVideo(item)) {
        photos = [ item.product.video ];
      } else {
        photos = [ item.product.photo ];
      }
      if (photos.length == 0) return [];
      
      return photos;
    },
    onProductsPreview() {
      const products = [];
      const items = this.$props.items;

      for (let i = 0; i < items.length; i++) {
        let photos = this.getItemPhotos(items[i], true);
        products.push({ data: items[i], photos: photos });
      }
      this.photos = [];
      this.products = products;
      this.productDialog = true;
    },
    async onPhotoSelected(payload) {
      const type = payload.item.product.productType;
      const isVideo = this.isVideo(payload.item);
      
      if (isVideo) {
        await this.getEventById(payload.item.catalog.catalogId);
        this.previewVideos = [{
          videoId: payload.item.product?.video?.videoId,
          highResolutionUrl: this.getDemoVideoUrl(type),
          title: payload.item.product.title,
        }];
        this.currentVideoIndex = 0;
        this.videoPreviewDialog = true;
        return;
      }

      this.photos = this.getItemPhotos(payload.item);
      this.photosIndex = payload.index;
      this.photosDialog = true;
    },
    updateWidth() {
      if (this.$root.isMobile) {
        
        const container = document.getElementById('product-list');
        if (container == null) return;
        
        this.placeholderWidth = container.offsetWidth - ((144 + 12) * this.$props.items.length);
        if (this.placeholderWidth < 0) this.placeholderWidth = 0;

      } else {
        this.placeholderWidth = (174 + 20) * this.$props.items.length;
      }
    },
    getDemoVideoUrl(type) {
      if (type === this.productTypes.video) return this.event?.videos?.preview?.fullVideoPreview || '';
      return '';
    },
    /*
      TO DO: заменить тут создание экземпляра axios на обращение к методу VUEX (когда уберу в этом проекте TypeScript).
    */
    async getEventById(eventId) {
      const api = axios.create({
        responseType: 'json',
        baseURL: '/public/photo-service/api/v1',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const result = await api
        .get(`/events/${eventId}`, { 
          headers: {
            'Accept-Language': this.defaultLanguage,
          },
        })
        .then(response => {
          return { status: response.status, data: response.data };
        })
        .catch(error => {
          if (error.response === undefined) {
            // on network error
            return { status: 1001, data: null };
          } else {
            // on other errors
            return { status: error.response.status, data: null };
          }
        });
      
      this.event = result.data;

      return result;      
    },
  },
  created() {
    this.updateWidth();
    window.addEventListener('resize', () => {
        setTimeout(() => { this.updateWidth(); }, 250);
      }
    );
  },
  mounted() {
    this.updateWidth();
  }
};
</script>


<style lang="scss" scoped>
  @import "./product-list";
</style>
